<template>
  <div v-if="asyncDataStatus_ready && synced" v-resize="onResize">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.articles.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="nastaviTrenutniArticle()"
        >
          Nov artikel
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="color: #0F998E">
        Razvrsti: <ButtonActionSortAZ class="ml-2" @click="sort('AZ')" /><ButtonActionSortZA class="mr-2" @click="sort('ZA')" /><ButtonActionSortCategoriesAZ class="mx-2" @click="sort('CategoriesAZ')" /><ButtonActionSortCategoriesZA class="mx-2" @click="sort('CategoriesZA')" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        Skupine:
        <br v-if="screenSizeIsSmall">
        <v-btn
          color="#0F998E"
          class="white--text ml-3"
          @click="selectAllCategories"
        >
          Izberi vse
        </v-btn>
        <v-btn
          color="#0F998E"
          class="white--text ml-3"
          @click="selectNoCategories"
        >
          Izberi nobeno
        </v-btn>
      </v-col>
      <v-col v-if="screenSizeIsSmall">
        <v-select
          v-model="selectedCategoryIds"
          :items="categories"
          :menu-props="{ maxHeight: '400' }"
          label="Skupine"
          multiple
          hint="Izberite željene skupine"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-col>
      <v-col cols="12 pt-0" v-else>
        <v-btn
          v-for="category of categories"
          :key="category.id"
          :color="category.color"
          class="mr-3 mb-3"
          :class="category.selected ? 'white--text' : ''"
          @click="toggleCategory(category)"
          :outlined="!category.selected"
        >
          {{category.name}}
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.articles.length">
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Naziv
                </th>
                <th class="text-left">
                  Cena
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  Enota
                </th>
                <th class="text-left" v-if="screenSizeIsSmall">
                  Skupina
                  Grupa
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  Skupina
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  Grupa
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  DDV
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  Aktiven
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  Vodenje zaloge
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="article in filteredArticles"
                :key="article.id"
              >
                <td :style="{'border-left': `5px solid ${article.category_color}`}">{{ article.name }}</td>
                <td>{{article.price | price}} €</td>
                <td v-if="!screenSizeIsSmall">{{ article.sell_measurement_unit_name }}</td>
                <td v-if="screenSizeIsSmall">{{ article.category_name }} <br><br>{{article.group_name}}</td>
                <td v-if="!screenSizeIsSmall">{{ article.category_name }}</td>
                <td v-if="!screenSizeIsSmall">{{article.group_name}}</td>
                <td v-if="!screenSizeIsSmall">{{article.tax_level_value}}%</td>
                <td v-if="!screenSizeIsSmall"><ActiveIcon :value="article.is_visible" /></td>
                <td v-if="!screenSizeIsSmall"><ActiveIcon :value="article.inventory_kept" /></td>
                <td class="text-right">
                  <!-- <ButtonActionEdit @click="$router.push({name: 'MyCompanyArticlesEdit', params: {id: article.id}})" /> -->
                  <!-- <ButtonActionDuplicate @click="$router.push({name: 'MyCompanyArticlesNew', params: {article: {...article, id: null, sort_order: null}}})" /> -->
                  <ButtonActionEdit @click="nastaviTrenutniId(article.id)" />
                  <ButtonActionDuplicate @click="nastaviTrenutniArticle(article)" />
                  <ButtonActionDelete @click="showDeleteArticleModal = true; deleteArticle = article" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega artikla uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje artikla"
      text="Ali ste prepričani, da želite izbrisati artikel? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteArticleModal"
      @confirmed="remove(deleteArticle)"
    />

    <MyCompanyArticlesEdit
      v-if="trenutniId !== null"
      :id="trenutniId ? trenutniId : null"
      @zapri="trenutniId = null; refre($event)"
    />

    <MyCompanyArticlesNew
      v-if="trenutniNovArticle !== null"
      :article="trenutniNovArticle.article"
      @refreshRepeat="refre($event)"
      @zapri="trenutniNovArticle = null; refre($event)"
    />

  </div>
  <app-spinner v-else>Pridobivanje artiklov..</app-spinner>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import responsive from '@/mixins/responsive'
import { siIncludes } from '@/utils/str'
import { debounce } from '@/utils/helpers'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import ButtonActionSortAZ from '@/components/ButtonActionSortAZ'
import ButtonActionSortZA from '@/components/ButtonActionSortZA'
import ButtonActionSortCategoriesAZ from '@/components/ButtonActionSortCategoriesAZ'
import ButtonActionSortCategoriesZA from '@/components/ButtonActionSortCategoriesZA'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDuplicate from '@/components/ButtonActionDuplicate'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import ActiveIcon from '@/components/ActiveIcon'
// import AppSpinner from '@/components/AppSpinner'
import { objectToArray } from '@/utils/object'
import MyCompanyArticlesEdit from '@/pages/MyCompanyArticlesEdit'
import MyCompanyArticlesNew from '@/pages/MyCompanyArticlesNew'

export default {
  components: {
    ConfirmDialog,
    ActiveIcon,
    ButtonActionSortAZ,
    ButtonActionSortZA,
    ButtonActionSortCategoriesAZ,
    ButtonActionSortCategoriesZA,
    ButtonActionEdit,
    ButtonActionDuplicate,
    ButtonActionDelete,
    MyCompanyArticlesEdit,
    MyCompanyArticlesNew,
    // AppSpinner
  },
  mixins: [
    asyncDataStatus,
    responsive
  ],
  data () {
    return {
      filter: '',
      articlesFiltered: null,
      synced: false,
      sortMethod: null,
      highlightCategories: false,
      showDeleteArticleModal: false,
      deleteArticle: null,
      categories: [],
      selectedCategoryIds: [],
      trenutniId: null,
      trenutniNovArticle: null
    }
  },
  computed: {
    articles () {
      let articles = objectToArray(this.$store.state.articles.items)
      if (this.sortMethod) {
        return articles.sort((a, b) => {
          if (this.sortMethod === 'AZ') {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          }
          if (this.sortMethod === 'ZA') {
            return a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1
          }
          if (this.sortMethod === 'CategoriesAZ') {
            return a.category_name.toLowerCase() > b.category_name.toLowerCase() ? 1 : -1
          }
          if (this.sortMethod === 'CategoriesZA') {
            return a.category_name.toLowerCase() > b.category_name.toLowerCase() ? -1 : 1
          }
        })
      }
      return articles.sort((a, b) => {
        if (a.category_name && b.category_name) {
          if (a.category_name.toLowerCase() > b.category_name.toLowerCase()) {
            return 1
          } else if (a.category_name.toLowerCase() < b.category_name.toLowerCase()) {
            return -1
          }

          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1
          } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1
          } else { // nothing to split them
            return 0
          }
        }
      })
    },
    filteredArticles () {
      return this.articlesFiltered
    }
  },
  methods: {
    ...mapActions('articles', ['loadItems', 'deleteItem']),
    ...mapActions('categories', { loadCategories: 'loadItems' }),
    refre (data) {
      return new Promise((resolve, reject) => {
        this.loadCategories()
        .then(response => {
          this.categories = objectToArray(this.$store.state.categories.items).map(cat => {
            cat.selected = this.selectedCategoryIds.includes(cat.id) || cat.id === data.category
            return cat
          }).sort((a, b) => a.name < b.name ? -1 : 1)
          if (data) {
            // this.selectedCategoryIds = this.categories.map(c => c.id)
            this.selectedCategoryIds.push(data.category)
          }
          this.loadItems()
            .then((articles) => {
              this.articlesFiltered = this.articles.filter(item => {
                return siIncludes({ haystack: `${item.name}`, needle: this.filter }) && this.isInActiveCategory(item)
              })
              // console.log(this.articlesFiltered)
              resolve()
            })
        })
        })
    },
    nastaviTrenutniArticle (artikel) {
      if (artikel) {
        // console.log(artikel)
        this.trenutniNovArticle = {
          article: { ...artikel, id: null, sort_order: null }
        }
      } else {
        this.trenutniNovArticle = {
          article: { ...artikel, id: null, sort_order: null }
        }
      }
    },
    nastaviTrenutniId (id) {
      this.trenutniId = id
    },
    remove (item) {
      deleteItem(item, this)
      setTimeout(() => {
        this.articlesFiltered = this.articles.filter(item => {
          return siIncludes({ haystack: `${item.name}`, needle: this.filter }) && this.isInActiveCategory(item)
        })
      }, 300)
    },
    sort (method) {
      this.sortMethod = method
      if (method === 'CategoriesAZ' || method === 'CategoriesZA') {
        this.highlightCategories = true
      } else {
        this.highlightCategories = false
      }
    },
    selectAllCategories () {
      this.categories = this.categories.map(cat => {
        cat.selected = true
        return cat
      })
      this.selectedCategoryIds = this.categories.map(c => c.id)
      this.articlesFiltered = this.articles.filter(item => {
        return siIncludes({ haystack: `${item.name}`, needle: this.filter }) && this.isInActiveCategory(item)
      })
    },
    selectNoCategories () {
      this.categories = this.categories.map(cat => {
        cat.selected = false
        return cat
      })
      this.selectedCategoryIds = []
      this.articlesFiltered = this.articles.filter(item => {
        return siIncludes({ haystack: `${item.name}`, needle: this.filter }) && this.isInActiveCategory(item)
      })
    },
    toggleCategory (category) {
      this.categories = this.categories.map(cat => {
        if (cat.id === category.id) {
          cat.selected = !cat.selected
        }
        return cat
      })
      this.selectedCategoryIds = this.categories.filter(c => !!c.selected).map(c => c.id)
      this.articlesFiltered = this.articles.filter(item => {
        return siIncludes({ haystack: `${item.name}`, needle: this.filter }) && this.isInActiveCategory(item)
      })
    },
    isInActiveCategory (article) {
      return this.selectedCategoryIds.includes(article.category)
    },
    getArticlesDebounced: debounce(function(newVal) {
      this.articlesFiltered = this.articles.filter(item => {
        return siIncludes({ haystack: `${item.name}`, needle: newVal }) && this.isInActiveCategory(item)
      })
      setTimeout(() => {
        console.log(this.articlesFiltered)
        this.asyncDataStatus_fetched()
        this.synced = true
      }, 200)
    }, 300)
  },
  created () {
    this.synced = false
    this.asyncDataStatus_ready = false
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      this.checkScreenSize()
      this.loadCategories()
        .then(response => {
          this.categories = objectToArray(this.$store.state.categories.items).map(cat => {
            cat.selected = true
            return cat
          })/* .sort((a, b) => a.name < b.name ? 1 : -1) */
          this.selectedCategoryIds = this.categories.map(c => c.id)
          this.refre()
            .then(() => {
              this.asyncDataStatus_fetched()
              this.synced = true
            })
        })
    }
  },
  watch: {
    /* articles (newValue) {
      this.loadItems()
    } */
    filter: {
      handler (val) {
        this.getArticlesDebounced(val)
      },
      immediate: false,
    }
  }
}
</script>
